<template>
  <section>
    <div class="container">
      <div class="container">
        <loading-component v-if="isLoading" />
        <no-result-component v-else-if="keywords == null || keywords.length <= 0" />
        <div v-else>
          <page-title-component title="Welcome texts" :subtitle="competitionName" />
          <section class="section">
            <div class="instructions">
              <h2>Instructions</h2>
              <ul>
                <li>This document contains separate pages with unique keywords ready for printing</li>
                <li>Make sure that the total number of pages are at least <strong>{{ keywords.length }}</strong>!</li>
                <li>Remove header and footer from the document on the printer settings</li>
                <li>Skip the first page, since it will contain this text</li>
                <li>Do not print with Chrome! It will not print all pages. Use Edge or some other browser. </li>
              </ul>
            </div>

            <div class="container welcome">
              <div v-for="kw in keywords" v-bind:key="kw.id">
                <div class="container">
                  <h1>Välkommen till Norrlands Hembryggarträff {{ welcomeTextSuffix }}</h1>
                  <h2>Tema: {{ theme }}</h2>
                  <div class="stand-out-section">
                    <p>Detta papper innehåller ditt personliga kontrollord för röstningen. Behåll det under hela kvällen då det kan behövas senare för att logga in igen.</p>
                    <br />
                    <p>
                      Ditt kontrollord:
                      <strong>{{ kw.keyword }}</strong>
                    </p>
                  </div>
                  <p>Du har fått ett mail skickat till den mailadress du använde när du anmälde dig till träffen; följ
                    länken för att reservera ditt kontrollord och komma till omröstningen. Kom ihåg att länken är personlig.</p>
                  <br />
                  <p>
                      Vi har förbättrat vårt röstningssystem. Nu kan du betygsätta alla öl från 0,5 till 10 poäng.
                      Du kan rösta på så många öl du vill under hela evenemanget, och justera dina poäng när som helst tills röstningen stänger.
                      Du kan rösta på öl i två klasser, <strong>TEMA</strong> och <strong>ÖPPEN</strong>.<br />
                      Du kan också rösta på bästa <strong>ETIKETT</strong> - här röstar du
                      endast på det bidrag du tycker är bäst.
                      <br />
                      Självklart röstar du inte på dig själv. ;) Omröstningen är självklart helt frivillig och helt anonym.
                      <br />
                      <strong>Om ni har frågor rörande omröstningen så kan tillgängliga arrangörer hjälpa er.</strong>
                  </p>
                  <hr>
                  <img src="../assets/nh_current_route.png" />
                  <p>
                    <i>Scanna QR-koden för att komma till öllistan</i>
                  </p>
                  <p>Vi rekommenderar att du märker pappret så det kan komma till rätta om du skulle råka tappa det
                  </p>
                  <br />
                  <p>Namn:
                    .........................................................................................................
                  </p>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import PageTitleComponent from "./PageTitle.vue";
import apiService from "./../services/apiService";

export default {
  name: "WelcomeTexts",
  components: {
    PageTitleComponent
  },
  props: {
    competitionId: String,
    competitionName: String,
    apiKey: String,
    welcomeTextSuffix: String,
    theme: String
  },
  data() {
    return {
      isLoading: false,
      keywords: []
    };
  },
  async created() {
    this.isLoading = true;
    try {

      if (!(this.apiKey)) {
        this.apiKey = this.$route.query.apiKey;
      }
      if (!(this.competitionId)) {
        this.competitionId = this.$route.query.competitionId;
      }

      await this.fetch();
    } catch (err) {
      console.log(err);
    } finally {
      this.isLoading = false;
    }
  },
  methods: {
    async fetch() {
      var managerToken = {
        competitionId: this.competitionId,
        apiKey: this.apiKey
      };

      const keywords = await apiService.getKeyWords(managerToken);

      this.keywords = keywords.data;
      console.log(this.keywords);
    }
  }
};
</script>

<style scoped>
.welcome {
  margin: 20px;
}

.instructions {
  padding: 50px;
  border: dotted black;
}

.stand-out-section {
  padding-top: 25px;
  padding-bottom: 25px;
  font-size: 1.3rem;
}

ul {
  list-style-type: circle;
  padding: 5px;
  list-style-position: inside;
}

@media print {
  h1 {
    page-break-before: always;
  }
}
</style>